import { render, staticRenderFns } from "./transfer-phone-number-popover.vue?vue&type=template&id=e2525d44"
import script from "./transfer-phone-number-popover.vue?vue&type=script&lang=js"
export * from "./transfer-phone-number-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports